// CANONICAL COPY (GH #7115). src/constants/obligations/obl-sdlc-peer-review.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-sdlc-peer-review',
  title: 'Peer review gate: all merges to development are approved',
  description:
    'Every pull request merged to the development branch must have at least one approving review from a reviewer other than the author before the merge is completed. Verified automatically via the GitHub PR audit integration.',
  category: 'risk',
  scfIds: ['SCF-DEV-001', 'SCF-DEV-008', 'SCF-RSK-001'],
  cadence: { frequency: '1m', anchor: 'domain' },
  strategy: 'integration',
  integrationKey: 'github-pr-audit',
  fulfilmentCriteria: [
    {
      type: 'integration-check',
      integrationKey: 'github-pr-audit',
      check: 'allMergesHavePeerReview',
      description:
        'All PRs merged to development in the last 90 days have at least one approving review from a reviewer other than the PR author',
    },
  ],
};
